import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import SiteRoutes from "./routes";
const app = (
  <BrowserRouter>
    <SiteRoutes />
  </BrowserRouter>
);
const root = document.getElementById("root");
const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
if (root.hasChildNodes() && root.dataset.route === pathname) {
  ReactDOM.hydrateRoot(root, app);
} else {
  ReactDOM.createRoot(root).render(app);
}
